import { skipToken } from '@reduxjs/toolkit/dist/query';

import {
  CfiAddress,
  CfiCompany,
  normalizeCfiAddress,
  useLazyFetchCfisQuery,
} from './cfisService';
import { useCfiQueryArgs } from './useCfis';

export type CfiLookupResult =
  | { status: 'resolved'; cfi: CfiCompany }
  | { status: 'unavailable' };

export const useLazyCfi = () => {
  const queryArgs = useCfiQueryArgs();
  const [fetchCfis] = useLazyFetchCfisQuery();

  const getCfiUsingAddress = async (
    address?: CfiAddress
  ): Promise<CfiLookupResult> => {
    const normalizedAddress = normalizeCfiAddress(address);

    if (queryArgs === skipToken || !queryArgs.params || !normalizedAddress) {
      return { status: 'unavailable' };
    }

    try {
      const cfis = await fetchCfis(
        { params: { ...queryArgs.params, ...normalizedAddress } },
        true
      ).unwrap();
      const cfi = cfis[0];

      if (
        !cfi ||
        typeof cfi.distance !== 'number' ||
        !Number.isFinite(cfi.distance)
      ) {
        return { status: 'unavailable' };
      }

      return { status: 'resolved', cfi };
    } catch {
      return { status: 'unavailable' };
    }
  };

  return { getCfiUsingAddress };
};
